import { render, staticRenderFns } from "./CommissionTable.vue?vue&type=template&id=a00466be"
import script from "./CommissionTable.vue?vue&type=script&lang=js"
export * from "./CommissionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports